import React, { useState, useRef, useEffect } from "react";
import { useMenuVisibility } from "../../providers/menuVisibilityProvider";
import OuterDiv from "../../components/Common/OuterDivComponent";
import EvalutionType from "./SourcingType";
import JobDetails from "./JobDetails";
import AddJobHeader from "./Components/AddJobHeader";
import AIChat from "./AI-Chat";
import ReviewJobBar from "./ReviewJobBar";
import Thankyou from "./Thankyou";
import { useLocation, useHistory } from "react-router-dom";
import { useMessagePopup } from "context/messagePopContext";
import { OverlayLoader } from "components/Common/Loader/loaderWithOverlay";
import { AddJobProvider } from "./context/AddJobContext";
import { useSelector } from "react-redux";
import { RootState } from "store";

const AddJob: React.FC = () => {
  const [activeStep, setActiveStep] = useState<string>("createJob");
  const [sourcingType, setSourcingType] = useState<string>("");
  const createJobSubmitBtnRef = useRef<any>();
  const jobDetailsSubmitBtnRef = useRef<any>();
  const AIChatSubmitBtnRef = useRef<any>();
  const ReviewJobBarSubmitBtnRef = useRef<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const location = useLocation();
  const history = useHistory();
  const message = useMessagePopup();
  const expertId = useSelector((state: RootState) => state.auth.user.expertId);

  const params = new URLSearchParams(location.search);
  const jId = params.get("jobId") || "";
  const [jobId, setJobId] = useState(jId);
  const isEdit = Boolean(jId) && window.location.pathname.includes("edit-job");

  const handleSetJobId = (jobId: string, step: string) => {
    const newSearchParams = new URLSearchParams(window.location.search);

    if (jobId === "EXPERT_EVAL" || jobId === "SOURCE_TALENT") {
      setSourcingType(jobId);
    }

    if (!["EXPERT_EVAL", "SOURCE_TALENT"].includes(jobId)) {
      newSearchParams.set("jobId", jobId);
      setJobId(jobId);
    }

    newSearchParams.set("step", step);

    history.push({
      pathname: window.location.pathname,
      search: newSearchParams.toString(),
    });

    setActiveStep(step);
  };

  const handleNext = () => {
    switch (activeStep) {
      case "createJob":
        createJobSubmitBtnRef.current.click();
        break;
      case "jobDetails":
        jobDetailsSubmitBtnRef.current.click();
        break;
      case "aiChat":
        AIChatSubmitBtnRef.current.click();
        break;
      case "reviewJobBar":
        ReviewJobBarSubmitBtnRef.current.click();
        break;
      default:
        alert("Invalid step");
        break;
    }
  }

  const JDsetSourcingType = (sourcingType: string) => {
    setSourcingType(sourcingType);
  }
  
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const step = params.get("step") || "";
    if (isEdit && !step) {
      setActiveStep("jobDetails");
    } else {
      setActiveStep(step || "createJob");
    }
  }, [jobId, location.search]);

  const handleCancel = () => {
    message.confirm("Are you sure to cancel?", () => history.push("/job-search"));
  };

  const { isMenuVisible } = useMenuVisibility()!;

  const [jobTitle, setJobTitle] = useState('')

  return (
    <AddJobProvider
      value={{ jobId, expertId, sourcingType, setLoading, handleSetJobId, isEdit, jobTitle, setJobTitle }}
    >
      <OuterDiv style={{ background: "#f2f7fa" }}>
        <AddJobHeader
          onNext={handleNext}
          onCancel={handleCancel}
          disableNext={false}
          step={activeStep}
          sourcingType={sourcingType}
        />

        <OverlayLoader loading={loading} />

        {activeStep === "createJob" && (
          <EvalutionType submitBtnRef={jobDetailsSubmitBtnRef} />
        )}

        {activeStep === "jobDetails" && (
          <JobDetails submitBtnRef={jobDetailsSubmitBtnRef} setSourcingType={JDsetSourcingType} />
        )}

        {activeStep === "aiChat" && (
          <AIChat submitBtnRef={AIChatSubmitBtnRef} />
        )}

        {activeStep === "reviewJobBar" && (
          <ReviewJobBar submitBtnRef={ReviewJobBarSubmitBtnRef} />
        )}

        {activeStep === "thankyou" && <Thankyou />}
      </OuterDiv>
    </AddJobProvider>
  );
};

export default AddJob;